import React, { useState, useEffect } from "react";
import RatingGameGeometry from "../../components/RatingGameGeometry";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";

var realQuestions;
var questionsGenerated = false;

function shuffleArray(array)
{
  
  for (let i = array.length - 1; i > 0; i--)
  {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateQuestionsProper(questions){
  var allQuestions = [];
  for (var diff = 0; diff < 10; diff++){ 
      allQuestions[diff] = new Array();
    for (var z = 0; z < 12; z++){
      //get random question
      //console.log("diff = " + diff)
      let randomQuestionNum = Math.floor(Math.random() * (questions[diff].length));
      //console.log("random num is " + randomQuestionNum)
      let randomQuestion = questions[diff][randomQuestionNum]

      //console.log(randomQuestion)

      //convert to proper question text
      let questionText = randomQuestion.question;

      //work out correct answer for each
      let generatedCalculation = 1;
      //set the subject

      //create answers
      let questionAnswers = [];
      let correctAnswer = randomQuestion.right_answer;
      let wrongAnswers = [];
      questionAnswers.push({
        correct: true,
        value: correctAnswer
      });
      //push all 3 incorrect answers

        wrongAnswers.push({
          correct: false,
          value: randomQuestion.other_answer_1
        });
        wrongAnswers.push({
          correct: false,
          value: randomQuestion.other_answer_2
        });
        wrongAnswers.push({
          correct: false,
          value: randomQuestion.other_answer_3
        });

        questionAnswers.push({
          correct: false,
           value: randomQuestion.other_answer_1
        });
        questionAnswers.push({
          correct: false,
           value: randomQuestion.other_answer_2
        });
        questionAnswers.push({
          correct: false,
           value: randomQuestion.other_answer_3
        });
      //add to list
      let questionObj = {
        question: questionText,
        answers: questionAnswers,
        image: randomQuestion.image,
        topic_id: randomQuestion.topic_id
      };
      //RANDOM ANSWER PLACE
      shuffleArray(questionObj.answers);
      
      allQuestions[diff].push(questionObj)
    }
    
  }
  console.log(allQuestions);
  return allQuestions;
}

export default function Rating({ ...props }) {
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);

  useEffect(() => {
    if (!questionsGenerated && questions != undefined){
      console.log(questions);
      console.log("hello");
      realQuestions = GenerateQuestionsProper(questions);
    }
  },[questions]);


  console.log(realQuestions);
  return realQuestions !== undefined ? (
    <RatingGameGeometry
      questionslist={realQuestions}
      playAudio={true}
      onBack={() => {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
    <LoadingScreen />
  );
}
